define('core/views/IframeGifRichMediaView',[
    'core/views/IframeRichMediaView',
], function (
    IframeRichMediaView
) {
    'use strict';

    return IframeRichMediaView.extend({
        insertContentNode: function ($node) {
            IframeRichMediaView.prototype.insertContentNode.call(this, $node);

            this.loaderNode.width(this.getMediaDimensions().width);
        },

        createContentNode: function () {
            var $node = IframeRichMediaView.prototype.createContentNode.apply(this, arguments);

            $node.attr(this.getMediaDimensions());

            return $node;
        },

        calculateDeferredHeight: function () {
            return this.getMediaDimensions().height;
        },

        displayPlaceholder: function () {
            IframeRichMediaView.prototype.displayPlaceholder.call(this);

            var dimensions = this.getMediaDimensions();
            this.contentNode.height(dimensions.height).width(dimensions.width);
        },
    });
});

